import { Directive, Input, OnChanges } from '@angular/core';
import { ColumnBase, ColumnComponent } from '@progress/kendo-angular-grid';

/** Column -> configurable key, for columns that are neither bound by `field` nor titled like their key. */
export const configKeyByColumn = new WeakMap<ColumnBase, string>();

/**
 * Ties a `<kendo-grid-column>` to its `ConfigurableGridColumn.key` so `<app-column-configurator>` can
 * reorder it. Only needed when the column has no `field` and its title differs from the configurable one.
 */
@Directive({
    selector: 'kendo-grid-column[appConfigKey]',
    standalone: false
})
export class ConfigKeyDirective implements OnChanges {
    @Input() appConfigKey: string;

    constructor(private readonly column: ColumnComponent) {}

    ngOnChanges(): void {
        configKeyByColumn.set(this.column, this.appConfigKey);
    }
}
